import { apolloProvider } from '@/apollo-provider.js'
import { faturamento } from '@/services/kpis.js'
import {
  CLONE_BENEFIT,
  QUERY_BENEFIT_DISTRIBUTION,
  QUERY_BENEFIT_MOVEMENT_HISTORY,
  MUTATION_CREATE_BENEFIT_MOVEMENT_HISTORY_REPORT,
  QUERY_FIND_BENEFIT_METRICS_BY_ID,
} from '../graphql'
import { microservicesUrls } from '@/plugins/microservices/microservices'

export default {
  async getBenefitMetricsById({ state, commit, dispatch }, variables) {
    const { findBenefitById } = await apolloProvider.defaultClient
      .query({
        query: QUERY_FIND_BENEFIT_METRICS_BY_ID,
        variables,
        fetchPolicy: 'no-cache',
        context: {
          uri: microservicesUrls['benefitsManager'],
        },
      })
      .then(({ data: { findBenefitById } }) => {
        return { findBenefitById }
      })
    const { metrics, ...rest } = findBenefitById
    commit('SET_METRICS', metrics)
    commit('SET_BENEFIT', rest)
  },
  async getBenefitMovementHistory({ state, commit, dispatch }, variables) {
    const { benefitMovementHistory } = await apolloProvider.defaultClient
      .query({
        query: QUERY_BENEFIT_MOVEMENT_HISTORY,
        variables,
        fetchPolicy: 'no-cache',
        context: {
          uri: microservicesUrls['benefitsManager'],
        },
      })
      .then(({ data: { benefitMovementHistory } }) => {
        return { benefitMovementHistory }
      })
    commit('SET_BENEFIT_MOVEMENT_HISTORY', benefitMovementHistory)
  },
  async getBenefitDistribution({ state, commit, dispatch }, variables) {
    const { benefitDistribution } = await apolloProvider.defaultClient
      .query({
        query: QUERY_BENEFIT_DISTRIBUTION,
        variables,
        fetchPolicy: 'no-cache',
        context: {
          uri: microservicesUrls['benefitsManager'],
        },
      })
      .then(({ data: { benefitDistribution } }) => {
        return { benefitDistribution }
      })
    commit('SET_BENEFIT_DISTRIBUTION', benefitDistribution)
  },
  exportBenefitMovementHistoryReport({ state }, variables) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_CREATE_BENEFIT_MOVEMENT_HISTORY_REPORT,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['asyncJobs'],
          },
        })
        .then(
          (data) => {
            resolve(data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  cloneBenefit({ state }, variables) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: CLONE_BENEFIT,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['benefitsManager'],
          },
        })
        .then(
          ({ data: { cloneBenefit } }) => {
            resolve(cloneBenefit)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
  getRevenue({ state, commit }, filter) {
    return new Promise((resolve, reject) => {
      faturamento(filter).then(
        ({ data: { VAL_FATURAMENTO } }) => {
          resolve(VAL_FATURAMENTO)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
}
